var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Thêm mới lớp học",
        visible: _vm.dialogVisible,
        size: "sm",
        "panel-icon": "el-icon-school",
        "panel-title": "Thông tin lớp",
        "panel-subtitle": "Tạo lớp học mới trong khối",
        "confirm-loading": _vm.loadingButton,
        "confirm-disabled": !_vm.showSaveChange,
        "confirm-text": "Lưu",
        "confirm-type": "primary",
        "cancel-text": "Hủy",
        "cancel-type": "",
        "cancel-icon": "",
        "confirm-icon": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "before-close": _vm.handleClose,
        cancel: _vm.handleClose,
        confirm: _vm.handleSave,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Chọn khối", prop: "idGrade" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "sk-u-w-full",
                  attrs: { placeholder: "Chọn khối" },
                  model: {
                    value: _vm.dataForm.idGrade,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "idGrade", $$v)
                    },
                    expression: "dataForm.idGrade",
                  },
                },
                _vm._l(_vm.gradeOfSchoolList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { value: item.id, label: item.gradeName },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Tên lớp học", prop: "className" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.dataForm.idGrade === "",
                  placeholder: "Nhập tên lớp",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleSave.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.dataForm.className,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "className", $$v)
                  },
                  expression: "dataForm.className",
                },
              }),
              _vm.customErrorMessages.newNameKt
                ? _c(
                    "span",
                    { staticClass: "sk-note sk-note--danger sk-u-mt-12" },
                    [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.customErrorMessages.newNameKt)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "sk-u-mt-12",
              attrs: { label: "Mô tả", prop: "classDescription" },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 1,
                  autosize: "",
                  placeholder: "Nhập mô tả",
                },
                model: {
                  value: _vm.dataForm.classDescription,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "classDescription", $$v)
                  },
                  expression: "dataForm.classDescription",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }